/*eslint-disable */
import editName from './editName';

export default editName;
